import React from "react";
import { convertDate } from "../../../utils/generalLiveCenter";
import NextImage from "../../common/NextImage";

const PlayerPerformance = ({ data }) => {
  const getMatchOutcomeClass = (outcome) => {
    let outcomeClass;

    if (outcome === "W") {
      outcomeClass = "win";
    } else if (outcome === "L") {
      outcomeClass = "loss";
    } else {
      outcomeClass = "draw";
    }

    return outcomeClass;
  };
  const baseURL = process.env.REACT_APP_BASE_URL;
  return (
    <div className="player_performance">
      {data?.map((item, index) => (
        <div className="performance_round" key={item?.id || index}>
          <h3>
            Round <strong>{item?.rou}</strong>
          </h3>
          <div className="round_box">
            <div className="round_head">
              <span>{convertDate(item?.dt)}</span>
              <ul className="round_head_ul">
                <li>
                  <div className="round_image">
                    <NextImage
                      src={`${baseURL}/public/assets/images/svg/card-yellow.svg`}
                      width={11}
                      height={15}
                      alt="card"
                    />
                  </div>
                  <span>{item?.yc}</span>
                </li>
                <li>
                  <div className="round_image">
                    <NextImage
                      src={`${baseURL}/public/assets/images/svg/card-yellowred.svg`}
                      width={13}
                      height={17}
                      alt="card"
                    />
                  </div>
                  <span>{item?.syc}</span>
                </li>
                <li>
                  <div className="round_image">
                    <NextImage
                      src={`${baseURL}/public/assets/images/svg/card-red.svg`}
                      width={11}
                      height={15}
                      alt="card"
                    />
                  </div>
                  <span>{item?.rc}</span>
                </li>
              </ul>
            </div>
            <div className="round_body">
              <div className="rbody_lft">
                Opposite Team: <strong>{item?.oppt}</strong>
              </div>
              <div className="rbody_rgt">
                <div>{item?.ft}</div>
                <div
                  className={`icon_status ${getMatchOutcomeClass(item?.type)}`}
                >
                  <span>{item?.type}</span>
                </div>
              </div>
            </div>
            <div className="round_foot">
              <ul className="round_foot_ul">
                <li>
                  Starting XI: <strong>{item?.strtxi}</strong>
                </li>
                <li>
                  In: <strong>{item?.in}</strong>
                </li>
                <li>
                  Out: <strong>{item?.out}</strong>
                </li>
                <li>
                  Min Played: <strong>{item?.plyd}</strong>
                </li>
                <li>
                  Goals: <strong>{item?.goals}</strong>
                </li>
                <li>
                  Assists: <strong>{item?.asst}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlayerPerformance;
